import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DtpAccordionPanel, DtpAccordionGroup } from 'dtp-react-components';
import { Button, SelecaoMultipla } from '../../components';
import {
  tipoRegime,
} from '../../utils/listsSelect';
import { doGet } from '../../utils/requests';
import SelecaoEntidade from './SelecaoEntidade';
import SelecaoSuperintendencia from './SelecaoSuperintendencia';
import { ehPapelObservadorRelatorio } from '../../utils/helpers';

const participanteRGPS = '01000';

class FiltroRelatorioExigenciaAnalitico extends Component {
  constructor(props) {
    super(props);
    this.filtroRelatorioExigenciaAnalitico = JSON.parse(sessionStorage.getItem('filtroRelatorioExigenciaAnalitico'));
    this.state = {
      configComponenteSelecaoMultipla: {
        labelCombobox: 'Exigência',
        titulo: 'Tipos de exigência',
        exibirBotaoIncluir: true,
        exibirTabelaItens: true,
        retirarLinhaSeparadora: false,
        exibirComboBox: true,
      },
      participanteObservador: this.filtroRelatorioExigenciaAnalitico && this.filtroRelatorioExigenciaAnalitico.participanteObservador ?
        this.filtroRelatorioExigenciaAnalitico.participanteObservador : null,
      tipoRegimeObservador: this.filtroRelatorioExigenciaAnalitico && this.filtroRelatorioExigenciaAnalitico.tipoRegimeObservador ?
        this.filtroRelatorioExigenciaAnalitico.tipoRegimeObservador : null,
      participante: this.participante && this.filtroRelatorioExigenciaAnalitico.participante ?
        this.filtroRelatorioExigenciaAnalitico.participante : null,
      valorComboSelecaoMultipla: this.filtroRelatorioExigenciaAnalitico && this.filtroRelatorioExigenciaAnalitico.valorComboSelecaoMultipla ?
        this.filtroRelatorioExigenciaAnalitico.valorComboSelecaoMultipla : null,
      tipoEntidadeObservador: this.filtroRelatorioExigenciaAnalitico && this.filtroRelatorioExigenciaAnalitico.tipoEntidadeObservador ?
        this.filtroRelatorioExigenciaAnalitico.tipoEntidadeObservador : null,
      superintendencia: this.filtroRelatorioExigenciaAnalitico && this.filtroRelatorioExigenciaAnalitico.superintendencia ?
        this.filtroRelatorioExigenciaAnalitico.superintendencia : null,
      opcao: 2,
      estado: 2,
      lista: this.filtroRelatorioExigenciaAnalitico && this.filtroRelatorioExigenciaAnalitico.lista ? this.filtroRelatorioExigenciaAnalitico.lista : [],
      listaTiposRegimes: [],
      listaSuperintendencias: [],
      listaGexs: [],
      listaAps: [],
    };
  }

  componentDidMount() {
    if (sessionStorage.getItem('filtroRelatorioExigenciaAnalitico')) {
      this.handleSearch();
    }
    this.carregaUnidadesOrganicas(24, null, this.carregaSuperintendencias);
    this.carregarListaTiposRegimes();
  }

    handleSearch = () => {
      const participanteObservadorSelecionado = this.state.participanteObservador;
      const regimeSelecionado = this.state.tipoRegime;
      const entidadeSelecionada = this.state.tipoEntidade;
      const ufSelecionada = this.state.uf;
      const participanteSelecionado = this.state.participante;
      const opcaoSelecionada = this.state.opcao;
      const superintendenciaSelecionada = this.state.superintendencia;


      if (ehPapelObservadorRelatorio(this.props.papelUsuarioLogado) && !participanteObservadorSelecionado) {
        this.addMessage('Selecione o participante Observador.');
        return;
      }

      if (this.props.papelUsuarioLogado === 'analista-rgps' || participanteObservadorSelecionado === '01000') {
        if ((opcaoSelecionada && opcaoSelecionada !== 1)) {
          if (!superintendenciaSelecionada) {
            this.addMessage('Selecione uma superintendência.');
            return;
          }
        }
      } else if (opcaoSelecionada && opcaoSelecionada === 1) {
        if (!regimeSelecionado) {
          this.addMessage('Selecione um regime.');
          return;
        }
        if (regimeSelecionado !== 1 && !entidadeSelecionada) {
          this.addMessage('Selecione uma entidade.');
          return;
        }
        if ((entidadeSelecionada && entidadeSelecionada === 2) && ufSelecionada === null) {
          this.addMessage('Selecione uma UF.');
          return;
        }
        if (!participanteSelecionado) {
          this.addMessage('Selecione um participante.');
          return;
        }
      }

      this.props.handleSearchFilter(this.state);
    }

    carregaSuperintendencias = (response) => {
      const superintendencias = [];
      response.data.forEach((item) => {
        superintendencias.push({
          label: item.nomeUnidade,
          value: item.codigoUnidade,
        });
      });
      this.setState({ listaSuperintendencias: superintendencias });
    }

    carregaAps = (response) => {
      const aps = [];
      response.data.forEach((item) => {
        aps.push({
          label: item.nomeUnidade,
          value: item.codigoUnidade,
        });
      });
      this.setState({ listaAps: aps });
    }

    carregaGexs = (response) => {
      const gexs = [];
      response.data.forEach((item) => {
        gexs.push({
          label: item.nomeUnidade,
          value: item.codigoUnidade,
        });
      });
      this.setState({ listaGexs: gexs });
    }

    carregaUnidadesOrganicas = (categoria, codigoSuperior, sucesso) => {
      const parametros = {};
      if (codigoSuperior) {
        parametros.codigoSuperior = codigoSuperior;
      }
      if (categoria) {
        parametros.categoria = categoria;
      }
      doGet('unidades-organicas', sucesso, this.tratarErro, parametros);
    }

    carregarListaTiposRegimes = () => {
      this.setState({ listaTiposRegimes: tipoRegime });
    }

    handleSearchButton = () => {
      let filtroRelatorioExigenciaAnalitico = {
        participanteObservador: this.state.participanteObservador,
        tipoRegimeObservador: this.state.tipoRegimeObservador,
        participante: this.state.participante,
        valorComboSelecaoMultipla: this.state.valorComboSelecaoMultipla,
        tipoEntidadeObservador: this.state.tipoEntidadeObservador,
        superintendencia: this.state.superintendencia,
        lista: this.state.lista,
        listaTiposRegimes: this.state.listaTiposRegimes,
        listaSuperintendencias: this.state.listaSuperintendencias,
        listaGexs: this.state.listaGexs,
        listaAps: this.state.listaAps,
      };

      filtroRelatorioExigenciaAnalitico = JSON.stringify(filtroRelatorioExigenciaAnalitico);
      sessionStorage.setItem('filtroRelatorioExigenciaAnalitico', filtroRelatorioExigenciaAnalitico);

      this.handleSearch();
    }


    filtrarRegimes = () => {
      let retorno = this.state.listaTiposRegimes;
      if (this.props.papelUsuarioLogado === 'analista-rgps' ||
            (this.state.tipoRegimeObservador === 1 && ehPapelObservadorRelatorio(this.props.papelUsuarioLogado))) {
        retorno = this.state.listaTiposRegimes.filter(item => (item.label !== 'RGPS'));
      }
      if (this.props.papelUsuarioLogado !== 'analista-rgps' ||
            (this.state.tipoRegimeObservador === 2 && ehPapelObservadorRelatorio(this.props.papelUsuarioLogado))) {
        retorno = tipoRegime;
      }
      this.setState({ listaTiposRegimes: retorno });
    }

    trataFormulario = (limparCampos, campoAlterado) => {
      if (campoAlterado === 'tipoRegimeObservador' && limparCampos) {
        this.setState({
          tipoEntidadeObservador: null,
          uFObservador: null,
          participanteObservador: null,
          opcao: null,
          participante: null,
          tipoEntidade: null,
          uf: null,
        });
      }
      if (campoAlterado === 'tipoRegime' && limparCampos) {
        this.setState({ tipoEntidade: null, uF: null, participante: null });
      }

      if (campoAlterado === 'estado' && limparCampos) {
        this.setState({ valorComboSelecaoMultipla: null });
      }

      if (campoAlterado === 'tipoEntidade') {
        this.setState({ participante: null, uf: null });
      }
      if (campoAlterado === 'uf') {
        this.setState({ participante: null });
      }
      if (campoAlterado === 'superintendencia') {
        this.setState({ gex: null, aps: null, ente: null });
        if (this.state.superintendencia) {
          this.carregaUnidadesOrganicas(3, this.state.superintendencia, this.carregaGexs);
        }
      }
      if (campoAlterado === 'gex') {
        this.setState({ aps: null, ente: null });
        if (this.state.gex) {
          this.carregaUnidadesOrganicas(4, this.state.gex, this.carregaAps);
        }
      }
    }

    handleChange = (changeObj, name, callback = null) => {
      const limparCampos = false;

      if (name === 'tipoRegimeObservador') {
        if (changeObj.value === 1) {
          this.setState({ participanteObservador: participanteRGPS });
        }
        this.setState({ tipoRegimeObservador: changeObj.value }, this.filtrarRegimes);
        // if (this.state.tipoRegimeObservador !== null && (this.state.tipoRegimeObservador !== changeObj.value)) {
        //   limparCampos = true;
        // }
      }

      if (name === 'tipoRegime') {
        if (changeObj.value === 1) {
          this.setState({ participante: participanteRGPS });
        }
        // if (this.state.tipoRegime !== null && (this.state.tipoRegime !== changeObj.value)) {
        //   limparCampos = true;
        // }
      }

      if (callback === null) {
        // eslint-disable-next-line no-param-reassign
        callback = () => this.trataFormulario(limparCampos, name);
      }

      this.setState({
        [name]: changeObj.value,
      }, callback);
    }

    addMessage = (text) => {
      const message = {
        title: 'Titulo',
        text,
        timeout: 5000,
        type: 'danger',
      };
      window.DtpSnackbar.addMessage(message);
    };

    tratarErro = (error) => {
      if (error) {
        const { data } = { ...error };
        if (error.status) {
          if (error.status === 404) {
            this.addMessage('Nenhum resultado encontrado para o filtro informado.');
          } else {
            this.addMessage(`${data.mensagem}`);
          }
        } else {
          this.addMessage('Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.');
        }
      }
    };

    validaNaoEhSuperintendenciaESelecionouAmbos = () => {
      const opcaoAmbos = 1;
      return (!this.state.superintendencia && this.state.opcao === opcaoAmbos);
    }

    carregaUnidadesOrganicas = (categoria, codigoSuperior, sucesso) => {
      const parametros = {};
      if (codigoSuperior) {
        parametros.codigoSuperior = codigoSuperior;
      }
      if (categoria) {
        parametros.categoria = categoria;
      }
      doGet('unidades-organicas', sucesso, this.tratarErro, parametros);
    }

    validaEhPapelObservadorERegimeSelecionado = () => ((this.props.papelUsuarioLogado === 'analista-rgps') && this.state.opcao !== 1) ||
            (ehPapelObservadorRelatorio(this.props.papelUsuarioLogado) && this.state.tipoRegimeObservador === 1 && this.state.opcao !== 1)

    verificarTextoHintBotaoInclusao = () => {
      let retorno = 'item';
      switch (this.state.estado) {
        case '2':
          retorno = 'exigência';
          break;
        case '9':
          retorno = 'motivo';
          break;
        default:
          break;
      }
      return retorno;
    }


    montarFiltroPesquisa = () => (
      <React.Fragment>
        {ehPapelObservadorRelatorio(this.props.papelUsuarioLogado) ?
          <SelecaoEntidade
            handleChange={this.handleChange}
            destinatarios={this.props.destinatarios}
            papelUsuarioLogado={this.props.papelUsuarioLogado}
            titulo="Visualizar como"
            retirarLinhaSeparadora={false}
            tipoRegime={this.state.tipoRegimeObservador}
            tipoEntidade={this.state.tipoEntidadeObservador}
            uf={this.state.uFObservador}
            participante={this.state.participanteObservador}
            nomeAtributoComboboxRegime="tipoRegimeObservador"
            nomeAtributoComboboxParticipante="participanteObservador"
            nomeAtributoComboboxTipoEntidade="tipoEntidadeObservador"
            nomeAtributoComboboxUF="uFObservador"
            listaTiposRegimes={tipoRegime}
            labelComboboxParticipante="Participante Observador"
          /> : ''
                }
        {this.validaNaoEhSuperintendenciaESelecionouAmbos() ? (
          <SelecaoEntidade
            handleChange={this.handleChange}
            destinatarios={this.props.destinatarios}
            papelUsuarioLogado={this.props.papelUsuarioLogado}
            titulo=""
            retirarLinhaSeparadora
            tipoRegime={this.state.tipoRegime}
            tipoEntidade={this.state.tipoEntidade}
            uf={this.state.uf}
            participante={this.state.participante}
            nomeAtributoComboboxRegime="tipoRegime"
            nomeAtributoComboboxParticipante="participante"
            nomeAtributoComboboxTipoEntidade="tipoEntidade"
            nomeAtributoComboboxUF="uf"
            listaTiposRegimes={this.state.listaTiposRegimes}
            labelComboboxParticipante="Participante"
          />) : ''}
        {this.validaEhPapelObservadorERegimeSelecionado() ? (
          <SelecaoSuperintendencia
            handleChange={this.handleChange}
            tipoRegime={this.state.tipoRegime}
            papelUsuarioLogado={this.props.papelUsuarioLogado}
            listaSuperintendencias={this.state.listaSuperintendencias}
            listaGexs={this.state.listaGexs}
            listaAps={this.state.listaAps}
            superintendencia={this.state.superintendencia}
            gex={this.state.gex}
            aps={this.state.aps}
            tipoRegimeObservador={this.state.tipoRegimeObservador}
            titulo=""
            retirarLinhaSeparadora
          />
                ) : ''}
        <SelecaoMultipla
          handleChange={this.handleChange}
          configuracao={this.state.configComponenteSelecaoMultipla}
          estado="2"
          hint={this.verificarTextoHintBotaoInclusao()}
          listaEstadosComSelecaoMultipla={[2]}
          lista={this.state.lista}
          valorComboSelecaoMultipla={this.state.valorComboSelecaoMultipla}
        />
      </React.Fragment>
    )

    render() {
      const filtroPesquisa = this.montarFiltroPesquisa();

      if (!filtroPesquisa) {
        return null;
      }

      return (
        <DtpAccordionGroup>
          <DtpAccordionPanel
            headingId="relatorio"
            panelId="filtro-relatorio"
            icon="ico-filter"
            title={`${this.props.titulo}`}
          >
            {filtroPesquisa}
            <div className="row">
              <Button
                className="dtp-primary right"
                title="Pesquisar"
                onClick={() => this.handleSearchButton()}
                hint="Pesquisar de acordo com o filtro aplicado"
              />
            </div>
          </DtpAccordionPanel>
        </DtpAccordionGroup>
      );
    }
}

FiltroRelatorioExigenciaAnalitico.propTypes = {
  titulo: PropTypes.string.isRequired,
  papelUsuarioLogado: PropTypes.string.isRequired,
  destinatarios: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
  handleSearchFilter: PropTypes.func.isRequired,
};

FiltroRelatorioExigenciaAnalitico.defaultProps = {
  destinatarios: [],
};

export default FiltroRelatorioExigenciaAnalitico;



// WEBPACK FOOTER //
// ./src/pages/relatorios/FiltroRelatorioExigenciaAnalitico.jsx